module.exports = __webpack_public_path__ + "static/media/aam-growingup.a0fbbdde.jpg";